<template>
  <div class="content">
    <div class="social-icons">
      <a href="https://www.facebook.com">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-facebook.svg" />
      </a>
      <a href="https://www.instagram.com">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-instagram.svg" />
      </a>
      <a href="https://www.linkedin.com">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-linkedin.svg" />
      </a>
      <a href="https://www.twitter.com">
        <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-twitter.svg" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMedia",
};
</script>

<style scoped>
.content {
  flex: 1;
  display: flex;
  align-items: center;
}

.content .social-icons {
  display: flex;
  flex: 1.2;
  justify-content: space-evenly;
}

.content .social-text {
  flex: 1;
}

.content .social-text span {
  font-family: "Lato";
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// SocialMedia.vue?6c566957